



















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import * as api from '@/api';
import * as models from '@/api/models';
import { Toast } from 'vant';
import trainDetail from '@/components/TrainScheduling/detail.vue';
@Component({
  components: { trainDetail },
})
export default class ClassDetail extends Vue {
  classSolution: any = {};
  detailNames: string[] = ['1', '3'];
  showTrainDetail: boolean = false;
  trainScheduling: any = {};

  created() {
    if (this.$route.params.classSolution) {
      this.classSolution = JSON.parse(this.$route.params.classSolution);
    }
  }

  onClickLeft() {
    this.$router.go(-1);
  }

  toTrainDetail(trainScheduling: any) {
    this.showTrainDetail = true;
    this.trainScheduling = trainScheduling;
  }

  updateTrainDetailShow() {
    this.showTrainDetail = false;
  }
}
